import React from "react";
import { Modal, Button, Table, ButtonToolbar } from 'react-bootstrap';
import { host } from "../../../config";
import axios from 'axios';
import { any } from "bluebird";
import NotificationSystem from 'react-notification-system';

class BidDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showuploadbutton: false,
            selectedFiles: [],
            tour_id: null,
            bid_id: null,
            event_id:null,
            group_id:null,
            uploadedDocuments: [],
            showDocumentModal: false,
            showConfirmDialog:false,
            documentToDelete:null,
            notificationSystem:null

        }
    }
    componentDidMount() {
        this.setState({
            notificationSystem: this.refs.notificationSystem
        });
        const { tour, bid,city_id,group_id } = this.props;
        if (tour && tour.id) {
            this.setState({ tour_id: tour.id }, () => {
                if (bid) {
                    this.setState({ bid_id: bid.id }, () => {
                        this.fetchDocuments();
                    });
                }
                else if(group_id){
                    this.setState({group_id:group_id},()=>{
                        this.fetchDocuments();
                    })
                }
                else if(city_id){
                    this.setState({ event_id: city_id }, () => {
                        this.fetchDocuments();
                    });
                }
                else {
                    this.fetchDocuments();
                }
            });
        }
    }

    fetchDocuments = () => {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const tokenKey = auth.token;
        const { tour_id,bid_id,event_id } = this.state;
        const { upload_type,city_id,group_id} = this.props;
        let url
        if(city_id){
            url = `${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tour_id}&upload_type=${upload_type}&event_id=${city_id}&group_id=${group_id}`
        }
        else{
            url = `${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tour_id}&upload_type=${upload_type}&bid_id=${bid_id}`
        }
        axios.get(url, {
            headers: {
                Authorization: `Token ${tokenKey}`,
            },
        })
            .then((response) => {
                this.setState({ uploadedDocuments: response.data });
            })
            .catch((error) => {
                console.error('Error fetching documents:', error);
            });
        this.setState({
            showuploadbutton: false
        })
    };

    getFileData = (event) => {
        if (!event.target.value) {
            this.setState({
                showuploadbutton: false,
            });
        }
        else {
            this.setState({
                showuploadbutton: true,
                selectedFiles: event.target.files,
            });
        }
    };
    uploadDocument = (e) => {
        e.currentTarget.disabled=true
        const { selectedFiles, tour_id , bid_id } = this.state;

        const uploadPromises = Array.from(selectedFiles).map((file) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('document_name', file.name);
            formData.append('document_type', file.type);
            formData.append('uploaded_date', new Date().toISOString());
            formData.append('tour_id', tour_id);
            formData.append('bid_id',bid_id);
            if (this.props.tourp) {
                const uploadedBy = `${this.props.tourp.first_name} ${this.props.tourp.last_name}`;
                formData.append('uploaded_by', uploadedBy);
            }
            else {
                const uploadedBy = `${this.props.tour.primary_agent_profile.first_name} ${this.props.tour.primary_agent_profile.last_name}`;
                formData.append('uploaded_by', uploadedBy);
            }
            const tourName = `${this.props.tour.name}`
            formData.append('tour_name', tourName);
            formData.append('upload_type', 'Bid Response')

            const uploadUrl = `${host}/api/participants_documents/upload_documents/`;

            const auth = JSON.parse(sessionStorage.getItem('auth'));
            const tokenKey = auth.token;

            return axios.post(uploadUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Token ${tokenKey}`,
                },
            })
                .then(() => {

                })
                .catch((error) => {
                    console.error('Error uploading document:', error);
                });
        });

        Promise.all(uploadPromises)
            .then(() => {
                this.fetchDocuments()
                // All documents uploaded
                // Perform actions after all documents are uploaded, if needed
            });
    };
    viewDocument = (document) => {
        this.setState({ showDocumentModal: true, selectedDocument: document });
    };

    closeDocumentModal = () => {
        this.setState({ showDocumentModal: false, selectedDocument: null });
    };


    mapMimeType = (mimeType) => {
        const mimeTypeMap = {
            'application/pdf': 'PDF',
            'application/msword': 'DOC',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
            'image/jpeg': 'JPEG Image',
            'image/png': 'PNG Image',
            // Add more mappings as needed
        };
        return mimeTypeMap[mimeType] || 'Other';
    };
    renderDocumentContent = () => {
        const { selectedDocument } = this.state;
        const {upload_type} = this.props
        let folder 
        if (selectedDocument?selectedDocument.upload_type === 'Tour Group':''){
            folder = 'tours'
        }
        else if (selectedDocument?selectedDocument.upload_type === 'Bid Group':''){
            folder = 'BidGroupDoc'
        }
        else{
            folder = 'BidResponseDoc'
        }

        try {
            if (!selectedDocument) {
                return null;
            }

            const tourName = encodeURIComponent(`${this.props.tour.name}`);
            let content;

            const supportedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'image/jpeg',
                'image/png',
            ];

            if (supportedTypes.includes(selectedDocument.document_type)) {
                const documentUrl = `https://storage.googleapis.com/catch_documents/${folder}/${tourName}/${encodeURIComponent(
                    selectedDocument.document_name
                )}`;

                if (selectedDocument.document_type === 'application/pdf') {
                    content = (
                        <embed
                            src={documentUrl}
                            type="application/pdf"
                            style={{ width: '100%', height: '500px' }}
                        />
                    );
                } else if (selectedDocument.document_type.startsWith('image/')) {
                    content = (
                        <img
                            src={documentUrl}
                            alt={selectedDocument.document_name}
                            style={{ width: '100%' }}
                        />
                    );
                } else if (
                    selectedDocument.document_type === 'application/msword' ||
                    selectedDocument.document_type ===
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    selectedDocument.document_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ) {
                    content = (
                        <iframe
                            src={`https://view.officeapps.live.com/op/view.aspx?src=${documentUrl}`}
                            style={{ width: '100%', height: '500px' }}
                        />
                    );
                }
            } else {
                content = <p>Document type not supported for preview.</p>;
            }

            return content;
        } catch (error) {
            console.error('Error rendering document content:', error);
            return <p>Error displaying document.</p>;
        }
    };

    deleteDocument = (document) => {
        this.setState({ showConfirmDialog: true, documentToDelete: document });
    };

    removeDocumentAction = () => {
        const { documentToDelete } = this.state;

        const tourName = `${this.props.tour.name}`;
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const tokenKey = auth.token;

        if (documentToDelete) {
            axios
                .delete(`${host}/api/participants_documents/?name=${documentToDelete.document_name}&tour_name=${tourName}&id=${documentToDelete.id}`, {
                    headers: {
                        Authorization: `Token ${tokenKey}`,
                    },
                })
                .then(() => {
                    // On successful deletion
                    this.fetchDocuments(); // Fetch updated documents
                    this.setState({ showConfirmDialog: false, documentToDelete: null }); // Close confirmation modal
                })
                .catch((error) => {
                    console.error(`Error deleting document with ID ${documentToDelete.id}:`, error);
                });
        } else {
            console.error('No document selected for deletion');
        }
    };
    closeModal = () => {
        this.setState({ showConfirmDialog: false, documentToDelete: null });
    };


    downloadDocument = (documents) => {
        let folder
        if (documents.upload_type==='Tour Group'){
            folder = 'tours'
        }
        else if(documents.upload_type === 'Bid Group'){
            folder = 'BidGroupDoc'
        }
        else{
            folder = 'BidResponseDoc'
        }
        const tourName = encodeURIComponent(`${this.props.tour.name}`);
        const documentName = encodeURIComponent(documents.document_name);
        const downloadUrl = `https://storage.googleapis.com/catch_documents/${folder}/${tourName}/${documentName}`;

        if (documents.document_type === 'application/pdf') {
            // For PDF files, open in a new tab
            window.open(downloadUrl, '_blank');
        } else {
            // For other file types, initiate download using anchor element
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', documents.document_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Show success notification after download
            this.showNotification('success', 'Document Downloaded successfully!!');
        }
    };

    showNotification = (level, message) => {
        if (this.state.notificationSystem) {
            this.state.notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 8 // Auto-dismiss the notification after 5 seconds
            });
        }
    };
    closeModal=()=>{
        this.setState({showConfirmDialog:false})
    }


    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <Modal id='documentUpload' show={this.props.show} onHide={this.props.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.upload_type === 'Bid Response'?'Add Documents':'View Hotel Documents'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.upload_type === 'Bid Response' &&(
                            <div>
                            <input type='file' className='fileinput' multiple onChange={this.getFileData} />
                            {this.state.showuploadbutton && 
                            <Button className="booking-btn"  onClick={(e)=>this.uploadDocument(e)}>Upload Documents</Button>}
                        </div>
                        )}
                        {/* <div>
                            <input type='file' className='fileinput' multiple onChange={this.getFileData} />
                            <Button bsStyle="success" onClick={this.uploadDocument} >Upload Documents</Button>
                        </div> */}
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Document Name</th>
                                    <th>Document Type</th>
                                    <th>Upload Date</th>
                                    <th>Upload By</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.uploadedDocuments.map((document, index) => (
                                    <tr key={index}>
                                        <td>{document.document_name}</td>
                                        <td>{this.mapMimeType(document.document_type)}</td>
                                        <td>{document.upload_date}</td>
                                        <td>{document.uploaded_by}</td>
                                        <td className='Action-btn' >
                                            <Button bsStyle="info" onClick={() => this.viewDocument(document)}>View</Button> &nbsp;
                                            <Button bsStyle="info"><i className="fa fa-download" aria-hidden="true" onClick={() => this.downloadDocument(document)} ></i></Button> &nbsp;
                                            {this.props.upload_type === 'Bid Response' &&(
                                                <Button bsStyle="danger" onClick={() => this.deleteDocument(document)}>Delete</Button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>{/* Add your footer content here */}</Modal.Footer>
                </Modal>
                <Modal id='documentUpload' show={this.state.showDocumentModal} onHide={this.closeDocumentModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Document</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderDocumentContent()}
                    </Modal.Body>
                </Modal>;

                {this.state.showConfirmDialog && (
                    <Modal show={this.state.showConfirmDialog} onHide={this.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Document</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Are you sure you want to delete {this.state.documentToDelete ? this.state.documentToDelete.document_name : 'this document'}?</p>
                            <ButtonToolbar style={{ float: 'right' }}>
                                <Button bsStyle="danger" onClick={this.removeDocumentAction}>Confirm</Button>
                                <Button bsStyle="default" onClick={this.closeModal}>Cancel</Button>
                            </ButtonToolbar>
                        </Modal.Body>
                        <Modal.Footer style={{ clear: 'both' }} />
                    </Modal>
                )}
            </div>

        )
    }
}
export default BidDocuments


// WEBPACK FOOTER //
// src/routes/booking/components/BidDocuments.js